<i18n
  src="@/locales/views/customer/query/containers_intermediated/show_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <div>
    <go-back-link
      :text="$t('labels.go-back-link')"
      :name="routeName('list_containers')"
      :params="{
        customer_id: customer_id,
        agro_exporter_process_id: agro_exporter_process_id
      }"
    />

    <bread-crumbs
      :labels="[module_name, agro_exporter_process?.name]"
    ></bread-crumbs>

    <div class="mt-8" v-if="load_data_general">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-slate-200" v-if="container">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.container_code }}
                </dd>
              </div>
              <div class="sm:col-span-3"></div>
            </div>
            <div
              v-if="container.exportation"
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-3">
                <div class="sm:col-span-3">
                  <dt class="label-data">
                    <template
                      v-if="container.exportation?.exportation_type_id == 0"
                    >
                      {{ $t("model.exportation.booking_code_0") }}
                    </template>
                    <template
                      v-else-if="
                        container.exportation?.exportation_type_id == 1
                      "
                    >
                      {{ $t("model.exportation.booking_code_1") }}
                    </template>
                    <template v-else>
                      {{ $t("model.exportation.booking_code_0") }}
                    </template>
                  </dt>
                  <dd class="content-data">
                    <exportation-type
                      :exportation_type_id="
                        container.exportation?.exportation_type_id
                      "
                      only_icon="true"
                    /><span class="icon-space"></span
                    >{{ container.exportation?.booking_code }}
                  </dd>
                </div>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.status") }}
                </dt>
                <dd class="content-data">
                  <exportation-status
                    :status_id="container.exportation?.status_id"
                  />
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.origin_export") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.origin_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.destination_export") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.destination_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.departured_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.exportation?.departured_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.arrived_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.exportation?.arrived_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.shipping_line") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.shipping_line?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.ship") }}
                </dt>
                <dd class="content-data">
                  {{ container.exportation?.ship }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.packing_house") }}
                </dt>
                <dd class="content-data">
                  {{ container.packing_house_names.join(", ") }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.packing_house") }}
                </dt>
                <dd class="content-data">
                  {{ container.provider_names.join(", ") }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.load_date") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(container.load_date) }}
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.rows_package_groups") }}
                </dt>
                <dd class="content-data">
                  {{ container.rows_package_groups }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.cols_package_groups") }}
                </dt>
                <dd class="content-data">
                  {{ container.cols_package_groups }}
                </dd>
              </div>
            </div>

            <div
              v-if="container.thermo_code"
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.thermo_code") }}
                </dt>
                <dd class="content-data">
                  {{ container.thermo_code }}
                </dd>
              </div>
            </div>

            <div
              v-if="container.container_sealings.length > 0"
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.container_sealings") }}
                </dt>
                <dd class="content-data">
                  <ul>
                    <li
                      v-for="container_sealing in container.container_sealings"
                      :key="container_sealing.id"
                    >
                      <span class="text-slate-600">
                        {{ container_sealing.export_sealing.name }}:
                      </span>
                      {{ container_sealing.value }}
                    </li>
                  </ul>
                </dd>
              </div>
            </div>

            <!-- Section for container attribute values -->
            <div
              v-if="
                container.container_attribute_values &&
                container.container_attribute_values.length > 0
              "
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            >
              <div
                v-for="attribute_value in container.container_attribute_values"
                :key="attribute_value.id"
                class="sm:col-span-3"
              >
                <dt class="label-data">
                  {{
                    attribute_value.exporter_process_container_attribute
                      .agro_exporter_container_attribute.name
                  }}
                </dt>
                <dd class="content-data">
                  <template
                    v-if="
                      attribute_value.exporter_process_container_attribute
                        .data_type_id === 2 &&
                      attribute_value.exporter_process_container_attribute_option
                    "
                  >
                    {{
                      attribute_value
                        .exporter_process_container_attribute_option.value ||
                      attribute_value
                        .exporter_process_container_attribute_option.value
                    }}
                  </template>
                  <template v-else>
                    {{ attribute_value.value }}
                  </template>
                </dd>
              </div>
            </div>

            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <dt class="label-data">
                  {{ $t("model.container.comments") }}
                </dt>
                <dd class="content-data">
                  {{ container.comments }}
                </dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-else>
      <loading-message />
    </template>
  </div>
</template>

<script>
import Requester from "@/views/customer/requesters/query/containers_intermediated/show_container.js";
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";

export default {
  name: "CustomerQueryBasicContainersShowContainer",
  components: {
    ExportationStatus,
    ExportationType
  },
  props: ["customer_id", "agro_exporter_process_id", "container_id"],
  data() {
    return {
      container: null,
      agro_exporter_process: null,
      load_data_general: false
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      const response = await Requester.fetchAgroExporterProcess(
        this.customer_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(
        this.customer_id,
        this.agro_exporter_process_id,
        this.container_id
      );

      this.container = response.data;

      this.load_data_general = true;
    }
  },
  computed: {},
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporterProcess();
        this.fetchContainer();
      })
    );
  }
};
</script>
